import React from "react";
import { List, Card, Button, Avatar, Icon, Rate, Popconfirm, Tag } from "antd";
const { Meta } = Card;
export function AchievementList({
  technicalSkills,
  item,
  showModal,
  editSkill,
  deleteItem
}) {
  const confirm = index => e => {
    deleteItem(index);
  };
  return (
    <List
      grid={{
        gutter: 8,
        xs: 1,
      sm: 1,
      md: 1,
      lg: 3,
      xl: 3,
      xxl: 3,
      }}
      dataSource={technicalSkills&&[
        ...Object.keys(technicalSkills).map((el, index) => {
          return {
            ...technicalSkills[el],
            index
          };
        })
      ]}
      renderItem={item => {
        if (item && item.achievementName) {
          return (
            <List.Item key={item.achievementName}>
              <Card
              >
                <Meta
                 
                  title={item.achievementName}
                />

                <div
                  style={{
                    marginTop: 8
                  }}
                >
                  <Icon type="book" /> Authority : {item.achievementAuthority}{" "}
                </div>
                <div
                  style={{
                    marginTop: 2
                  }}
                >
                  <Icon type="clock-circle" /> : {item.achievementDate}{" "}
                </div>
             
               

              </Card>
            </List.Item>
          );
        }
      }}
    />
  );
}
